export default "__VITE_ASSET__4nvHF6r2__"